import { Box, styled } from '@mui/joy';

export const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  height: 45,
  backgroundColor: theme.palette.warning[50],
  fontSize: 14,
}));
